import { connect } from 'react-redux';

import { StoreState } from '../../reducers';
import NotesEditorPanel from '../../components/NotesEditorPanel';

const mapStateToProps = (state: StoreState) => {
	const {
		notes: { editor: { isOpened, noteId } },
		i18n: { locale },
	} = state;

	return {
		isOpened,
		noteId,
		locale,
	};
};

export default connect(mapStateToProps)(NotesEditorPanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/NotesEditorPanel/index.tsx